import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowDown18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M9.74999 14.1893L14.4696 9.46967L15.5303 10.5303L8.99993 17.0607L2.4696 10.5303L3.53026 9.46966L8.24999 14.1894L8.24999 1H9.74999L9.74999 14.1893Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowDown18.displayName = 'ArrowDown18';
export default ArrowDown18;
